import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'spermsourcedetails',
  templateUrl: './spermsourcedetails.component.html',
  styleUrls: ['./spermsourcedetails.component.scss']
})

export class SpermsourcedetailsPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public PatientId: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string; 
  public CycleNo: string;
  public CycleType: string;
  public MaleSource: string;
  public SourceFrom: string;
  public ExtDate: string;
  public ExtTime: string;
  public StorageLoc: string;
  public Technique: string;
  public DateofsampleCollection: string;
  public TimeofsampleCollection: string;
  public Volume: string;
  public Count: string;
  public MotileSpermMotility: string;
  public ActiveProgressivemotility: string;
  public CellularDebris: string;
  public MethodofPreparation: string;
  public IncubationTime: string;
  public MotileSpermCount: string;
  public Motility: string;
  public Notes: string;
  public SlideObserved: string;
  public StorageType: string;
  public StorageVolume: string;
  public StorageVolumeunits: string;
  public StorageDetails: string;
  public DSADOC: string;
  public DSASTIMULATION: string;
  public DSAANTAG: string;
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;

  CurrentSpermSourceDetailsController: SpermSourceDetailsController[];
  //SpermEndInfo: SpermSourceDetailsController;
  CurrentSpermSourceDetailsRequest: SpermSourceDetailsRequest;
  TreatmentCycleCode: any;
  LoadSperm() {
    this.CurrentSpermSourceDetailsRequest = new SpermSourceDetailsRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentSpermSourceDetailsRequest.Branch = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentSpermSourceDetailsRequest.ConditionalOperator = 10;
    this.CurrentSpermSourceDetailsRequest.FromDate = new Date();
    this.CurrentSpermSourceDetailsRequest.ToDate = new Date();
    //this.CurrentSpermSourceDetailsRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSpermSourceDetailsRequest.SemanDataCode = 0;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    //this.SemanDataCode = this.route.snapshot.paramMap.get('SemanDataCode');
    this.CurrentSpermSourceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetSpermSourceDetailsController();
  }

  GetSpermSourceDetailsController() {
    this.StartRefreshing();
    this.CurrentSpermSourceDetailsRequest.CycleCode = this.TreatmentCycleCode;
    //this.CurrentSpermSourceDetailsRequest.SemanDataCode = this.SemanDataCode;

    this.actorservice.GetSpermSourceDetailsController(this.CurrentSpermSourceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSpermSourceDetailsController = this.ApiResData.Result;
          //this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();          
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.MaleSource = this.route.snapshot.paramMap.get('MaleSource');
    this.SourceFrom = this.route.snapshot.paramMap.get('SourceFrom');
    this.ExtDate = this.route.snapshot.paramMap.get('ExtDate');
    this.ExtTime = this.route.snapshot.paramMap.get('ExtTime');
    this.StorageLoc = this.route.snapshot.paramMap.get('StorageLoc');
    this.Technique = this.route.snapshot.paramMap.get('Technique');
    this.DateofsampleCollection = this.route.snapshot.paramMap.get('DateofsampleCollection');
    this.TimeofsampleCollection = this.route.snapshot.paramMap.get('TimeofsampleCollection');
    this.Volume = this.route.snapshot.paramMap.get('Volume');
    this.Count = this.route.snapshot.paramMap.get('Count');
    this.MotileSpermMotility = this.route.snapshot.paramMap.get('MotileSpermMotility');
    this.ActiveProgressivemotility = this.route.snapshot.paramMap.get('ActiveProgressivemotility');
    this.CellularDebris = this.route.snapshot.paramMap.get('CellularDebris');
    this.MethodofPreparation = this.route.snapshot.paramMap.get('MethodofPreparation');
    this.IncubationTime = this.route.snapshot.paramMap.get('IncubationTime');
    this.MotileSpermCount = this.route.snapshot.paramMap.get('MotileSpermCount');
    this.Motility = this.route.snapshot.paramMap.get('Motility');
    this.Notes = this.route.snapshot.paramMap.get('Notes');
    this.SlideObserved = this.route.snapshot.paramMap.get('SlideObserved');
    this.StorageType = this.route.snapshot.paramMap.get('StorageType');
    this.StorageVolume = this.route.snapshot.paramMap.get('StorageVolume');
    this.StorageVolumeunits = this.route.snapshot.paramMap.get('StorageVolumeunits');
    this.StorageDetails = this.route.snapshot.paramMap.get('StorageDetails');
    this.DSADOC = this.route.snapshot.paramMap.get('DSADOC');
    this.DSASTIMULATION = this.route.snapshot.paramMap.get('DSASTIMULATION');
    this.DSAANTAG = this.route.snapshot.paramMap.get('DSAANTAG');
    
    this.LoadSperm();

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








